module.exports = __webpack_public_path__ + "static/media/user-edit.7ba1c4b3.png";